// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__37AyS","icon":"SortAdornment_icon__MymiF","up":"SortAdornment_up__fy_5u","down":"SortAdornment_down__3c32k","active":"SortAdornment_active__1ZYs9"};